<template>
    <div class="heartGrow">
        <div class="wraper">
            <!--心灵成长-->
            <section id="FMbg" class="FMbg" @click="SectionRight=false">
                <img :src="FmDetail.pageImg" width="100%" height="100%" alt="">
            </section>
            <section class="fmPage">
                <aside class="fmAside fmAsideOpen" id="menu" v-if="SectionLeft">
                    <nav class="fmNav clearfix fl" id="fmNav" >
                        <img :src="fmHeader" alt="" class="avatar">
                        <ul class="menu">
                            <li v-for="(item,index) in fmCategory" :key="index"
                                class="position-relative"
                                    @click="getFMList(item.categoryId,item.categoryName,index)">
                                <a :class="categoryId===item.categoryId?'selectText':''">
                                    {{item.categoryName}}
                                </a>
                                <div class="new" v-show="index===0">
                                </div>
                            </li>
                        </ul>
                    </nav>
                    <div class="fmLists fl" v-show="SectionRight">
                        <section class="columnFM">
                            <div v-show="categoryId!==''&&categoryId!==null">
                                <h1 class="columnTitle">{{sectionName}}<span class="fly"></span></h1>
                                <div class="notice mrgL20 mrgR20 mrgB30"><span> 给你动力，走出迷茫</span></div>
                            </div>
                            <div class="boxTitle " v-show="categoryId===''||categoryId===null">
                                <a href="javaScript:;">
                                    <div @click="selectOrder('newest')" class="sonBox float-left" :class="newsetHot==='newest'?'cur':''">
                                        最新
                                    </div>
                                </a>
                                <a href="javaScript:;">
                                    <div @click="selectOrder('hot')" class="sonBox float-right" :class="newsetHot==='hot'?'cur':''">
                                        最热
                                    </div>
                                </a>
                            </div>
                            <ul class="lists tagfmlist">
                                <li v-for="(item,index) in fmListData" :key="index"  @click="getFmData(item.id)"
                                    :class="fmId===item.id?'activelvzGray':''" class="delFloat padding-y padding-left">
                                    <a class="clearfix" href="javaScript:;">
                                        <div class="cover fl">
                                            <img :src="item.coverImg" alt="">
                                        </div>
                                        <div class="item float-right">
                                            <div class="h2" :title="item.title">
                                            {{item.title}}</div>
                                            <p class="author">主播：{{item.anchor}}</p>
                                            <p class="voicenice">
                                                <i class="iconvoice mrgR5 fmiconfont"></i>
                                                 点赞：{{item.upNum}}
                                                <i class="iconuphand mrgR5 mrgL30 fmiconfont"></i>
                                                播放：{{item.hits}}
                                            </p>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </section>
                    </div>
                </aside>
                <section class="fmMain">
                    <div class="logo">
                        <h1>心灵FM</h1>
                        倾心陪伴，一路有我
                    </div>
                    <section class="FMPlayer">
                        <h1>
                            <span class="sort">第 {{FmDetail.orderNum}} 期</span>
                            {{FmDetail.title}}
                        </h1>
                        <ul class="operate clearfix mrgB10 mrgT5">
                            <li class="fl"><i class="iconAuthor mrgR5 fmiconfont"></i>{{FmDetail.anchor}}</li>
                            <li class="fl"><i class="iconvoice mrgR5 fmiconfont"></i>{{FmDetail.hits}}</li>

                            <li class="fr tagfm"><span class="tagname">{{FmDetail.categoryName}}</span></li>
                        </ul>
                        <div class="summary mrgB10">
                            有人说：“只有张爱玲才可以同时承受灿烂夺目的喧闹及极度的孤寂。”本传记中坚持的一点，
                            相信是符合传记求真的宗旨的：即……决不把传记当做传奇，虽然张爱玲是个不乏传奇色彩的人物。
                        </div>
                        <div class="player mrgB10">
                            <audio ref="music"
                                   :autoplay="true"
                                   @pause="onPause"
                                   @play="onPlay"
                                   @timeupdate="onTimeupdate"
                                   @loadedmetadata="onLoadedmetadata"
                                   :src="FmDetail.audio"
                                   controls="controls"
                                   style="width: 450px;opacity: 0.8;margin-top: 30px;"
                            >
                            </audio>
                        </div>
                    </section>
                </section>
            </section>
        </div>
    </div>
</template>
<script>
    import{
        fmUserHeader,
        fmCategory,
        fmList,
        fmDetail,
    } from '../../../config/index'
    import aplayer from "vue-aplayer";
    export default {
        name: "heartGrow",
        components: { aplayer },
        data() {
            return {
                SectionRight: false,
                SectionLeft:true,
                fmHeader:'',
                description:'',
                fmCategory:[],
                pageIndex:1,
                pageSize:10,
                fmListData:[],
                sectionName:'',
                FmDetail:[],
                categoryId:null,
                fmFile:'',
                newsetHot:'newset',
                changeFmFile:'',
                fmId:''
            }
        },
        computed: {
            noMore() {
                return this.count >= 20
            },
            disabled() {
                return this.loading || this.noMore
            }
        },
        beforeDestroy(){
            this.$refs.music.playing = false
        },
        methods: {
            //选择排序
            selectOrder(val){
                this.newsetHot=val;
                this.getFmListData();
            },
            // 控制音频的播放与暂停
            startPlayOrPause() {
                return this.$refs.music.playing ? this.pause() : this.play()
            },
            // 播放音频
            play(){
                this.$refs.music.play()
            },
            // 暂停音频
            pause() {
                this.$refs.music.pause()
            },
            // 当音频播放
            onPlay() {
                this.$refs.music.playing = true
            },
            // 当音频暂停
            onPause() {
                this.$refs.music.playing = false
            },
            // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
            onTimeupdate(res) {
                // this.$refs.music.currentTime = res.target.currentTime
            },
            // 当加载语音流元数据完成后，会触发该事件的回调函数
            // 语音元数据主要是语音的长度之类的数据
            onLoadedmetadata(res) {
                this.$refs.music.maxTime = parseInt(res.target.duration)
            },
            // 拖动进度条，改变当前时间，index是进度条改变时的回调函数的参数0-100之间，需要换算成实际时间
            changeCurrentTime(index) {
                this.$refs.music.currentTime = parseInt(index / 100 * this.music.maxTime)
            },
// 进度条格式化toolTip
            formatProcessToolTip(index = 0) {
                index = parseInt(this.$refs.music.maxTime / 100 * index)
                return '进度条: ' + realFormatSecond(index)
            },
            getFMList(val,val1,index) {
                this.categoryId=val;
                this.SectionRight = true;
                this.SectionLeft = true;
                if(index===0){
                    this.newsetHot='newest';
                }else{
                    this.newsetHot='hot';
                }
                this.getFmListData(val);
                this.sectionName = val1;
            },
            async getFmUserHeader(){
                let res = await fmUserHeader();
                if (res.status){
                    this.fmHeader = res.data;
                }

            },
            async getFmCategory(){
                let res = await fmCategory();
                if (res.status){
                    this.fmCategory = res.data;
                }

            },
            async getFmListData(val){

                let res = await fmList(val,this.newsetHot,this.pageIndex,this.pageSize);
                if (res.status){
                    this.fmListData = res.data.data;
                    this.getFmData(this.fmListData[0].id);
                }

            },
            //获取fm详情
            async getFmData(val){
                this.fmId=val;
                let res = await fmDetail(val);
                if (res.status){
                    this.FmDetail = res.data;
                }
            }

        },
        filters: {
            // 使用组件过滤器来动态改变按钮的显示
            transPlayPause(value) {
                return value ? 'el-icon-video-pause' : 'el-icon-video-play '

            },
            // 将整数转化成时分秒
            formatSecond(second = 0) {
                return realFormatSecond(second)
            }
        },
        mounted() {

            //点击任意位置关闭区域弹窗
            document.addEventListener('click', (e) => {

                //获取弹窗对象
                const userCon = document.getElementById('menu');

                //判断弹窗对象中是否包含点击对象
                if (userCon && !userCon.contains(e.target)) {

                    //如果包含则跳转回之前的页面
                    this.SectionRight = false;
                    this.SectionLeft = true;
                }

            })

        },
        created() {
            this.getFmUserHeader();
            this.getFmCategory();
            this.getFmListData();

        }

    }
</script>

<style scoped lang="scss">
    .heartGrow {
        height: 100%;
        width: 100%;
        .activelvzGray{
            background-color: rgba(255, 255, 255, 0.2);
        }
        .boxTitle{
            margin:10px auto 10px auto;
            width:300px;
            height:50px;
            .sonBox{
                color: #ffffff;
                width:150px;
                text-align: center;
                line-height:50px;
                border : 1px solid #ffffff;
            }
            .float-left{
                border-right:0 ;
            }
        }
        .cur{
            background-color: #d1d1d6;
            color: #000!important;
        }
        .new{
            width:29px;
            height:16px;
            position: absolute;
            top:0;
            right:0;
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAQCAYAAADqDXTRAAABrklEQVR42r2UPWsCQRCGN0QsUqQSRCQkELAWRPAfRBCrtJaxSUrBoJVCwBTBQhtBSC2kjFhISKn/IBySJlgoSBDF7683O4zn5U4PScAbeHXf2dl59kY5ASGCUg0pWCDiXAn5oVgEVKUQdLlJUKTT+iIKdT2bAcOhpq8vIJUCvr8Bl4trwmGg2QQ8HvZ+P/tIRO2zEFuA+VxrcHKih9JeNsvK5/nb5+OauzuuKZXY0x75hwf2l5ebPhrU4QCWS6DbBT4+OHd+roeOx7tHRvn3d163WsB0Cnx+sq/XgcFAV69Bz86A1QoIhRiUSACBgB5K+zQqVU9PWmO6LE2GaopFfgC7Hej1gFptD5TW5TKPMhrVQ38H/b7JJOdvbzlHfrEAbDaGxuOcj8VMoE6nBqAb9vtAu70N3TVeqqcL0x+q0eCcogCdDp85PTWBGpsGg9pT7YOSaNwUuRz7TIY9gQ215lBStWo+XuOFCgV+Wq+XvdvN+5XKTujI4pfDiKBvFkPfCHoh9So1OTBssuZciL+EPHAvtTI0exSHDgm5offnGvgsdSSsCAm6lnqROv7P+R89f7194F/jTwAAAABJRU5ErkJggg==) no-repeat center center;
        }
        .menu{

        }
        .FMbg {
            overflow: hidden;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 1;
            background-color: #4a4862;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            width: 100%;
            height: 100%;

        }

        .fmPage {
            overflow: hidden;
            height: 100%;
            width: 100%;
            display: block;
            position: absolute;
            z-index: 2;
            .fmAside {

                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                float: right;
                display: block;
                z-index: 9999;
                position: absolute;
                right: 0;

                .fmNav {
                    width: 140px;
                    background-color: #222;
                    height: 100%;
                    position: relative;
                    float: left;

                    .avatar {
                        width: 80px;
                        height: 80px;
                        margin: 30px auto;
                        border: 2px solid #d3d3d3;
                        display: block;
                        border-radius: 50%;
                    }

                    .menu {
                        position: absolute;
                        -ms-overflow-style: none;
                        top: 144px;
                        left: 0;
                        right: 0;
                        bottom: 110px;
                        overflow: auto;
                        background-color: #000;
                        list-style: none;

                        li {
                            text-align: center;
                            cursor: pointer;
                        }

                    }

                    a {
                        color: #fff;
                        font-size: 16px;
                        display: block;
                        padding: 10px 0;
                        position: relative;
                        cursor: pointer;
                    }

                    .backPsy {
                        position: absolute;
                        bottom: 30px;
                        left: 0;
                        width: 140px;
                        text-align: center;
                    }
                }

                .fmLists {
                    width: 360px;
                    height: 100%;
                    overflow: auto;
                    float: left;

                    .columnFM {
                        .columnTitle {
                            font-size: 30px;
                            color: #00eaff;
                            font-family: "Microsoft Yahei";
                            height: 55px;
                            line-height: 55px;
                            text-align: center;
                            margin: 30px auto 20px;
                        }

                        .fly {
                            width: 79px;
                            height: 44px;
                            background: url(../img/flybg.png) no-repeat center center;
                            margin-left: 10px;
                            display: inline-block;
                        }

                        .notice {
                            font-size: 14px;
                            color: #fff;
                            border: 1px solid #fff;
                            border: 1px solid rgba(255, 255, 255, 0.4);
                            line-height: 200%;
                            padding: 10px;
                            margin-bottom: 30px;
                            margin-left: 20px;
                            margin-right: 20px;
                        }

                        ul {
                            list-style: none;

                            li {
                                a {
                                    display: block;
                                    color: #fff;


                                    .cover {
                                        position: relative;
                                        width: 100px;
                                        text-align: center;
                                        float: left;

                                        img {
                                            width: 100px;
                                            height: 90px;
                                            vertical-align: top;
                                        }
                                    }

                                    .item {
                                        width:219px;
                                        padding-left: 10px;
                                        float: right;
                                        .h2 {

                                            font-size: 16px;
                                            overflow: hidden;
                                            white-space: nowrap;
                                            text-overflow: ellipsis;
                                            font-weight: 400;
                                        }

                                        p {
                                            line-height: 30px;
                                            font-size: 14px;
                                        }

                                        .mrgL30 {
                                            margin-left: 30px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .fmMain {
                height: 100%;
                margin-right: 140px;
                position: relative;

                .logo {
                    color: #fff;
                    font-size: 12px;
                    padding: 30px 0 0 50px;

                    h1 {
                        font-size: 31px;
                    }
                }

                .FMPlayer {
                    width: 528px;
                    height: 314px;
                    padding: 20px 35px;
                    border: 1px solid #d9e6e9;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin: -178px 0 0 -300px;
                    background-color: rgba(0, 0, 0, 0.3);
                    filter: progid:DXImageTransform.Microsoft.gradient(enabled='true', startColorstr='#4D000000', endColorstr='#4D000000');
                    color: #fff;

                    h1 {
                        font-size: 22px;
                        line-height: 45px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-weight: 400;

                        .sort {
                            color: #00eaff;
                            border: 1px solid #00eaff;
                            border-radius: 5px;
                            font-size: 16px;
                            padding: 0 8px;
                            vertical-align: 1px;
                            margin-right: 8px;
                        }
                    }

                    .operate {
                        font-size: 14px;
                        margin-bottom: 10px;
                        margin-top: 5px;
                        list-style: none;
                        height: 30px;

                        li {
                            margin-right: 25px;
                        }

                        .fmiconfont {
                            font-size: 20px;
                        }

                        .fr {
                            float: right;
                        }

                        .fl {
                            float: left;
                        }

                        .mrgR5 {
                            margin-right: 5px;
                        }

                        .tagfm {
                            padding-left: 15px;
                            background: url('../img/download.png') no-repeat left center;
                            height: 24px;
                            margin-right: 3px;
                        }

                        .tagname {
                            border: 1px solid #fff;
                            border-left: 0;
                            padding: 0 8px;
                            border-top-right-radius: 5px;
                            border-bottom-right-radius: 5px;
                            font-size: 14px;
                            height: 24px;
                            line-height: 22px;
                            display: block;
                        }

                    }
                    .summary {
                        font-size: 14px;
                        height: 70px;
                        margin-bottom: 10px;
                    }

                }
            }
        }
    }
</style>
